<template>
    <div class="modal fade" id="modalEmail" tabindex="-1" role="dialog" aria-labelledby="modalEmail" aria-hidden="true">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="modalEmail">{{title}}</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="form-row">
                        <div class="form-group col-md-12">
                            <label class="m-0" v-html="message"></label>
                            <input type="text" v-model="email" class="form-control" :placeholder="$t('str.msg.email.label')" />
                        </div>
                        <div class="form-group col-md-12">
                            <label class="m-0">{{ $t('str.msg.total.bank.slip.label') }}</label>
                            <input v-money="money" id="total" v-model="total" type="text" class="form-control" :placeholder="$t('str.msg.total.bank.slip.label')" />
                        </div>
                        <div class="form-group col-md-12">
                            <label class="m-0">{{ $t('str.msg.due.date.label') }}</label>
                            <div class="cursor-pointer">
                                <datepicker class="form-control"  :language="ptBR"  :disabledDates="disabledDates" v-model="dueDate"></datepicker>
                            </div>
                        </div>
                    </div>
                
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-primary w-30" data-dismiss="modal" v-on:click="$emit('confirmation-return', {email: email,dueDate: dueDate, total: total})">{{yesText}}</button>
                    <button type="button" class="btn btn-secondary w-30" data-dismiss="modal" v-on:click="$emit('confirmation-return', 0)">{{cancelText}}</button>
                </div>
            </div>
        </div>
    </div>

</template>
<script>
import Datepicker from 'vuejs-datepicker';
import {ptBR} from 'vuejs-datepicker/dist/locale'
let maxDate = new Date();
maxDate.setMonth(maxDate.getMonth() + 1);

    export default {
        components: {
            Datepicker
        },
        props: ["title", "message", "cancelText", "yesText", "dueDate", "email", "total"],
        watch:{
            'email'(){
                this.email = this.email;
            },
            'total'(){
                this.total = this.total;
            }
        },
        data(){
            return {
                ptBR: ptBR,
                disabledDates: {
                    to: new Date(), // Disable all dates up to specific date,
                    from: maxDate, // Disable all dates after specific date
                },
                money: {
                    decimal: ',',
                    thousands: '.',
                    prefix: '',
                    suffix: '',
                    precision: 2,
                    masked: false
                }
            }
        },
        methods: {
          
        },
       
    }
</script>
